export const PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT = 'aud_desktop_bx775_saved_search_favorites_merge';
export const BX_MOBILE_BX1036_HIDE_POST_BUTTON = 'bx_mobile_bx1036_hide_post_button';

export const EXPERIMENTS = [PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT, BX_MOBILE_BX1036_HIDE_POST_BUTTON];
